import stringify from 'fast-json-stable-stringify';
import { DETAIL, LIST } from './common';

const DATASOURCES = 'datasources';
const DOCS = 'docs';
const LATEST = 'latest';
const DASHBOARD_FOLDERS = 'dashboard_folders';

export const datasourceQueryKeys = {
    all: [DATASOURCES],
    list: [DATASOURCES, LIST],
    latest: [DATASOURCES, LATEST],
    docs: [DATASOURCES, DOCS],
    /**
     * The key for the query that populates the object list on the
     * data source overview page.
     */
    objectPagedList: (configId: string, searchQuery: string) => [
        DATASOURCES,
        'PAGED_OBJECT_LIST',
        configId,
        searchQuery
    ],
    detail: (datasourceId?: string) => [DATASOURCES, DETAIL, stringify(datasourceId)],
    dashboardFolders: (configId: string) => [DATASOURCES, DASHBOARD_FOLDERS, configId]
};
